import { createApp } from 'vue'
import {createRouter,createWebHistory} from "vue-router";
import App from './App.vue'
import ElementPlus from 'element-plus'
import Home from './views/home.vue'
import Info from './views/info.vue'
import Fsbm from './views/fsbm.vue'
import videoInfo from './views/videoInfo.vue'
import NotFound from './views/NotFound.vue'
import compeForm from './views/compeForm'
import uploadPicture from './views/uploadPicture'
import schoolStationApply from './views/schoolStationApply'
import studentApply from './views/studentApply'


const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: Home,
            meta: { title: '食育中国 APP（食育科普）' }
        },
        {
            path: '/info/:id(\\d+)',
            component: Info,
            meta: { title: '食育中国 APP（食育科普）' }
        },
        {
            path: '/fsbm',
            component: Fsbm,
            meta: { title: '第二十二届中国食品安全大会报名' }
        },
        {
            path: '/videoInfo',
            component: videoInfo,
            meta: { title: '第五届食育膳食技能大赛' }
        },
        {
            path: '/compeForm',
            component: compeForm,
            meta: { title: '第五届食育膳食技能大赛' }
        },
        {
            path: '/uploadPicture',
            component: uploadPicture,
            meta: { title: '上传图片' }
        },
        {
            path: '/schoolStationApply',
            component: schoolStationApply,
            meta: { title: '食育小记者站申请' }
        },
        {
            path: '/studentApply',
            component: studentApply,
            meta: { title: '食育小记者申请' }
        },
        {
            path: '/:pathMatch(.*)',
            component: NotFound
        }
    ]
})
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

const app = createApp(App)
app.use(ElementPlus)
app.use(router).mount('#app')
